/*
    It's important that we NEVER REMOVE anything from this file. Adding is fine,
    but it's a one way operation. This file is NOT version-controlled within the
    application.

    Renaming variables is obviously fine, just don't touch the GUIDs.
*/

export const FIGHT_CATEGORY_ID = {
    CUSTOM: {
        Uncategorized: "3a93ef5d-71d5-4e48-a25e-d92f469c4aec",
    },
    CN: {
        Shriekwing: "60eb1195-477f-4598-98ea-da9d047f5e86",
        Altimor: "bd427279-d3e7-4379-9557-e075d0adf074",
        Hungering: "5f5a0ea1-6fcc-48f3-9cae-348f1d7f28ff",
        Artificer: "69ac0415-1400-4181-a903-41804de7064c",
        SunKing: "44edabd7-27bd-42f7-9a74-6526b3855d58",
        Darkvein: "62842110-6b90-479b-b67f-02bebfea48bc",
        Council: "2376a413-5212-4d00-bc45-d425768dcacc",
        Sludgefist: "cfe052a9-5e09-4748-892e-73f0c0765b95",
        Stoneborne: "24ac94a3-0c7a-4fcd-9262-8062d698cc3b",
        Denathrius: "c78f7a50-0e8d-43b4-96d8-020744751231",
    },
    SOD: {
        Tarra: "e68bece1-c1ae-4c62-9246-99c0288a999c",
        Eye: "fe5e6867-afd0-4e1c-bcd8-8c9d5a34f1f7",
        DayNine: "4bb12f97-08ae-4114-8e26-19cf235e7c76",
        Remnant: "b5e59ace-74db-477a-a537-cb073138892d",
        Soulrender: "043c4b7c-9bc8-410b-a6e3-e512a6891c82",
        Painsmith: "a5b5f042-52b0-4c16-87d1-8dc16319e542",
        Guardian: "a3a9f89f-cac9-47c2-bb89-aee6292fa7ab",
        Fatescribe: "17359dae-6511-4ccc-bdad-c1f30ffb69ac",
        KT: "45351484-ba93-4a71-a9bb-962fb033a381",
        Sylvanis: "42fb035a-ca4e-4234-a161-492342442b2d",
    },
    SOFO: {
        Guardian: "c0724221-7919-4161-85a9-bb74958cefb6",
        Skolex: "26371bdf-11e6-4621-8057-8a917cca4bd0",
        Xymox: "e8dfc34d-3bb1-4c73-b443-5b73914a4fd7",
        Dausegne: "dbb9a976-bcee-4e67-9576-011c94bf3d1a",
        Pantheon: "bac966bc-e3c5-4aab-8d42-7143af87f2d7",
        Lihuvim: "3dfddcef-ed65-47e9-99dd-c9bfd82d30c2",
        Halondrus: "6b3e7d7a-1c90-4c17-90c6-3d38ee5121b0",
        Anduin: "a86c571f-b1d5-46b7-9750-80176144baf5",
        Malganis: "4c64e6c2-698e-4e52-a8a9-b34668f37182",
        Rygelon: "c335f83c-1425-4cf2-9085-1d6c8a92b6a1",
        Jailer: "7ce5e246-cd2d-4cda-9b6d-57c53430a955",
    },
    VOTI: {
        Eranog: "33a903b5-480c-41e5-af47-ee2902c3c5ce",
        Terros: "e15eff02-f2ac-469e-a555-fa5813fd40f8",
        Council: "964ffe0e-e072-4fdd-8821-ef98b333821e",
        Spider: "aa2d3742-c037-44a4-8d73-dc7de0f1e666",
        Dathea: "b84595c7-25f0-412d-8ba8-b380256335bc",
        Kurog: "26578630-1604-4a29-a2a2-5f505e565f18",
        Broodkeeper: "66014ef3-dbdc-46e0-8705-8967155605eb",
        StormEater: "806251a0-80ea-4381-9f90-e9bb5fb1dea1"
    },
    ASC: {
        Kazzara: "a0c0a4b8-bbfa-40b7-b353-c22a8a1c5d35",
        Amalga: "79f84e23-2103-426e-9094-5951a76b1285",
        Experiments: "3b923828-404a-4f91-9f46-bf7490e55c4b",
        Assault: "6b6c63ad-20df-4cf9-9257-2a4363b7bd41",
        Rashok: "5c415b06-8e3c-4ba2-a09f-566b0ddb7917",
        Zskarn: "46085801-babd-41dc-acea-0b9ff1b0c7b0",
        Magmorax: "dc2c46bf-98f5-4d9c-aa54-43b21c4f555d",
        Neltharion: "05e3d9f2-42db-4d9f-88c4-e1c7c8878983",
        Sarkareth: "5ce71e01-21ed-43fe-aab6-36faae6e0f451"
    },
    ADH: {
        Gnarl: "0376ce82-abf2-4de0-b98a-9a890f966d36",
        Igira: "7a3517b2-c5ad-4623-ab5c-ffeb48047933",
        Volco: "e2297e38-a6b7-4761-8e7c-f78bb3079118",
        Council: "7023f9d7-4254-45df-a5ca-24796599409e",
        Larodar: "c1a4981f-95b9-449a-8b80-e2a3b3e26487",
        Nymue: "7c6d6725-0bb6-4af1-b62d-2e6d863e7b5d",
        Smolderon: "59055501-afeb-4764-a66e-807f94d26055",
        Tindral: "a7b1b131-ad10-4cc0-9669-96432b0838ca",
        Fyrakk: "04e2f5b4-636c-4fc7-971d-3e7057925b59"
    },
    NP: {
        Ulgrax: "a620604c-5e84-440d-83cc-8c40274729e5",
        Horror: "07473296-4652-4767-9fb7-28fd977fe3fc",
        Sikran: "37b9f9ff-83fb-42cb-8767-2028efd5105b",
        Rash: "70d75706-f6d5-4f0f-8cd1-a54d4feb9c44",
        Brood: "522e0146-4322-4477-b0ce-c345dcafbc18",
        Princess: "32a2c573-7268-4cc9-ab36-8721f1e32a2e",
        Court: "083c8379-4bd6-420e-9d51-a99f2b954c3d",
        Ansurek: "c28f16d6-8881-4ae5-96cd-38301d4d387ea"
    },
    LOU: {
        Vexie: "729bb6a7-f74f-4132-8d5c-69c93ac5e8a9",
        Carnage: "2ce6d67b-58ba-42ac-9bed-e9700c94bfbb",
        Rik: "bf410db0-973d-475a-b398-e7dd6a5c8e35",
        Stix: "9671e944-265e-48c4-bdb5-403e3e37e3e7",
        Sprocket: "bbf76340-38c8-4619-ae25-6fa4e4ec0e5b",
        Bandit: "582de60c-bdc4-41da-a3b8-52f682cf9bc5",
        Mugze: "ab0753ba-5a7d-4f08-88ca-c0aa7057b1f7",
        Gally: "5baad4f7-1b5d-4218-a3ee-54591c81d86c"
    },
}

/**
 * These IDs have to match the IDs we're using in the build-admin when we're
 * generating builds.
 */
export const CLASS_ID = {
    DK: "532f16f1-1e8b-4aba-af5d-17b292fc05fd",
    DH: "122a0a6d-d523-4cc2-a743-f3d42d3e7f02",
    DRUID: "3667f06e-ab4c-4b9d-8fd0-c6640ad86486",
    EVOKER: "fabd40be-24a8-4b80-8445-416b6e77e15f",
    HUNTER: "0a3fc2d5-66d5-42da-abc4-2bfbcf5bc9b3",
    MAGE: "843ce836-b215-488f-b73b-d08e3904ddca",
    MONK: "9223f4e8-8669-451e-815a-d53a19416c5a",
    PALADIN: "d056557a-1414-4958-b859-11656dfc0528",
    PRIEST: "f3899285-de29-4692-a640-98b5d03579ee",
    ROGUE: "5b6efded-e5dd-4429-adfd-2c6d3893e678",
    SHAMAN: "d599cd61-11ae-4a4d-a856-60d1c7f4572d",
    WARLOCK: "1d680db4-2a3f-4805-800d-00ea34d98880",
    WARRIOR: "0a450e25-065c-4c3c-a881-cea74cf08462",
}

export const CLASS_META = {
    [CLASS_ID.DK]: { name: "Death Knight", shortName: "dk", data_name: "DK" },
    [CLASS_ID.DH]: { name: "Demon Hunter", shortName: "dh", data_name: "DH" },
    [CLASS_ID.DRUID]: { name: "Druid", shortName: "druid", data_name: "DRUID" },
    [CLASS_ID.EVOKER]: { name: "Evoker", shortName: "evoker", data_name: "EVOKER" },
    [CLASS_ID.HUNTER]: { name: "Hunter", shortName: "hunter", data_name: "HUNTER" },
    [CLASS_ID.MAGE]: { name: "Mage", shortName: "mage", data_name: "MAGE" },
    [CLASS_ID.MONK]: { name: "Monk", shortName: "monk", data_name: "MONK" },
    [CLASS_ID.PALADIN]: { name: "Paladin", shortName: "paladin", data_name: "PALADIN" },
    [CLASS_ID.PRIEST]: { name: "Priest", shortName: "priest", data_name: "PRIEST" },
    [CLASS_ID.ROGUE]: { name: "Rogue", shortName: "rogue", data_name: "ROGUE" },
    [CLASS_ID.SHAMAN]: { name: "Shaman", shortName: "shaman", data_name: "SHAMAN" },
    [CLASS_ID.WARLOCK]: { name: "Warlock", shortName: "warlock", data_name: "WARLOCK" },
    [CLASS_ID.WARRIOR]: { name: "Warrior", shortName: "warrior", data_name: "WARRIOR" },
}
